export const KB_ABOUT_CHANGE =
    'https://help.patientfusion.com/s/article/how-do-I-access-my-health-records-after-patient-fusion-retires';
export const KB_SAVE_RECORDS =
    'https://help.patientfusion.com/s/article/How-does-a-patient-and-or-patient-authorized-representative-view-download-and-transmit-patient-health-data-from-Patient-Fusion';
